// removed by extract-text-webpack-plugin
module.exports = {"classModal":"SimpleModal-classModal-b945fd6e","classModalContent":"SimpleModal-classModalContent-92241e91","fadeIn":"SimpleModal-fadeIn-bf0b2a9c","classModalOpen":"SimpleModal-classModalOpen-4cc7c524","classModalClose":"SimpleModal-classModalClose-bedfa476","classModalHidden":"SimpleModal-classModalHidden-88bc6a7b","classModalIcon":"SimpleModal-classModalIcon-78bee853"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/SimpleModal.scss
// module id = 848
// module chunks = 0